import Scrollbar from 'smooth-scrollbar';

$(document).ready(function () {
    initScrollbar();
});

window.initScrollbar = function () {
    initScrollbar();
};

function initScrollbar() {
    let continuousScrolling = false;

    if (('ontouchstart' in window) || (navigator.msMaxTouchPoints > 0)) {
        continuousScrolling = true;
    }

    Scrollbar.initAll({continuousScrolling: continuousScrolling});
}